// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { productGridCardStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
        padding-bottom: 10px;
    `,
};
productGridCardStyles.imageWrapper = {
    css: css`
        margin: auto;
        padding: 10px 50px;
    `,
};
productGridCardStyles.sponsoredText = {
    css: css`
        font-size: 0.9em;
        opacity: 0.5;
        position: absolute;
        top: 12px;
    `,
};
productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: initial;
        `,
    },
    image: {
        css: css`
            width: initial;
            height: auto;
            max-height: 100%;
            ${xScreen("lte", "md")} {
                width: 90px;
            }
        `,
    },
};
productGridCardStyles.productGridContainerImageStyledWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
productGridCardStyles.productGridContainerInfoStyledWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        ${xScreen("lte", "md")} {
            height: 100%;
        }
    `,
};
productGridCardStyles.infoImageStyledWrapper = {
    css: css`
        ${xScreen("gt", "md")} {
            display: none;
        }
    `,
};
productGridCardStyles.rightSideDetailsContainer = {
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    `,
};
productGridCardStyles.productListProductInformation = {
    descriptionStyles: {
        productDetailLink: {
            ...createProductDescriptionStyles({
                productDetailLink: {
                    typographyProps: {
                        size: 12,
                        css: css`
                            min-height: 48px;
                            ${ellipsis(3)}
                        `,
                    },
                },
            }).productDetailLink,
        },
    },
    descriptionGridItem: {
        css: css`
            padding-bottom: 0;
        `,
    },
};
productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                & > .bottom-section {
                    margin-top: initial;

                    ${xScreen("lte", "md")} {
                        margin-top: 8px;
                        height: auto;
                    }
                }
            `,
        },
    },
    availabilityWrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                flex-direction: column;
            }
        `,
    },
};
productGridCardStyles.productPriceAndActionsBottomStyles = {
    productGridContainer: {
        container: {
            css: css`
                & > .bottom-section {
                    margin-top: initial;
                    .price-availability-container {
                        margin-top: auto;
                        ${xScreen("lte", "md")} {
                            display: none;
                        }
                    }
                }
                ${xScreen("lte", "md")} {
                    height: auto;
                }
            `,
        },

        availability: {
            css: css`
                ${xScreen("lte", "md")} {
                    display: none;
                }
            `,
        },
    },
};
